/**
 * Build a Clash Royale "copy deck" deep link that imports the 8-card deck
 * in-game. Mirrors QBot's `generateCopyDeckUrl` (shared/utils/deckLink.ts),
 * format verified from Deck Shop Pro:
 *
 *   https://link.clashroyale.com/en?clashroyale://copyDeck?deck={ids}&slots={evo}&tt=159000000&l=QLASH
 *
 * `tt=159000000` is the default tower troop — required, the game ignores the
 * deck if it's 0. `slots` carries the per-card evolution level (0 = none).
 */
export function crDeckImportUrl(
  cards: ReadonlyArray<{ id: number; evolutionLevel?: number }>,
): string {
  const eight = cards.slice(0, 8);
  const ids = eight.map((c) => c.id).join(';');
  const slots = eight.map((c) => c.evolutionLevel || 0).join(';');
  return `https://link.clashroyale.com/en?clashroyale://copyDeck?deck=${ids}&slots=${slots}&tt=159000000&l=QLASH`;
}
